import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { FileViewer }
  from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer';
import { addQuery } from 'Helpers/Query';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { Alert } from '@material-ui/lab';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  paper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.facet.primaryBlue,
    color: 'white',
    margin: theme.spacing(0, 2, 3, 2),
    padding: theme.spacing(3.25, 2),
    fontWeight: 425,
    borderRadius: theme.radius.md,
  },
  planButton: {
    padding: theme.spacing(0, 1),
    marginRight: theme.spacing(1),
    borderRadius: '16px',
  },
  viewPlanButton: {
    backgroundColor: theme.palette.facet.seafoam,
    color: theme.palette.facet.primaryBlue,
    fontWeight: 450,
    '&:hover': {
      backgroundColor: theme.palette.facet.accentGreen,
      color: theme.palette.facet.primaryBlue,
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  alert: {
    margin: theme.spacing(2),
  },
});

const PlanMessageBanner = ({
  className,
  classes,
  messageResource,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [planIsMissing, setPlanIsMissing] = useState(false);

  useEffect(() => {
    if (!messageResource) {
      return;
    }
    const file = messageResource.attr('attachments')?.resources()?.head();
    const hasFile = !file?.link('self')?.url();
    setPlanIsMissing(hasFile);
  }, [messageResource]);

  const openPlan = () => {
    try {
      // Plans should have one relevant attachment, the plan HTML file that gets uploaded when the plan is posted to Messages. It will be the most recent attachment.
      const file = messageResource?.attr('attachments').resources().last();
      addQuery({ attachmentSelfLink: file.link('self').url() });
      setIsPreviewOpen(true);
    } catch (err) {
      displayErrorMessage(err, err.errors || 'Failed to open Plan');
    }
  };

  if (planIsMissing) {
    return (
      <Alert
        className={classes.alert}
        severity="info"
      >
        <Typography
          variant="h6"
        >
          {'This plan file has been removed.'}
        </Typography>
      </Alert>
    );
  }
  return (
    <Paper className={classNames(classes.paper, className)} variant="tight">
      {messageResource.attr('content')}
      <Button
        className={classNames(classes.planButton, classes.viewPlanButton, classes.noWrap)}
        onClick={openPlan}
        variant="contained"
        color="secondary"
        test="view-plan"
      >
        {'View'}
      </Button>
      <FileViewer
        attachmentResources={messageResource?.attr('attachments').resources().list()}
        isOpen={isPreviewOpen}
        closeModal={() => setIsPreviewOpen(false)}
        eventCategory={'Messages'}
      />
    </Paper>
  );
};

PlanMessageBanner.defaultProps = {
  className: '',
};

PlanMessageBanner.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  messageResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlanMessageBanner);
